import { z } from "zod";

import { ErrorMessages } from "@/app/_module/constants";

export type TLoginSchema = z.infer<typeof loginSchema>;
export type T2FASchema = z.infer<typeof twoFASchema>;

export const loginSchema = z.object({
  username: z.string().email(ErrorMessages.invalidEmail),
  // ⚠️ SIGN-IN validates presence only, never composition. Complexity rules
  // belong on sign-UP: enforcing min(8) here (a) locks out any older account
  // whose password predates the policy, and (b) tells an attacker the minimum
  // length before they've sent a single request. Wrong passwords are the
  // server's verdict, not the form's.
  password: z.string().min(1, "Password is required"),
});

export const twoFASchema = z.object({
  code: z.string().min(1, "Code is required"),
});
